export const SHARED_ITEM_INVITE_STATUSES = ["PENDING", "ACCEPTED", "REJECTED"] as const;

export const SHARED_ITEM_KINDS = ["NOTE", "COLLECTION", "SPACE", "UNKNOWN"] as const;

export const SHARED_ITEM_KIND_SELECTABLE = ["NOTE", "COLLECTION"] as const;

export const ASSIGNABLE_ROLE_KINDS = [
  "EDITOR",
  "VIEWER",
  "DIRECT_CONTACT",
  "INDIRECT_CONTACT",
] as const;

export const SHARED_ITEM_INVITE_URL_ROLE_KINDS = ASSIGNABLE_ROLE_KINDS;

export const SHARED_ITEM_INVITE_STATUS_LABELS: Record<string, string> = {
  PENDING: "Pending",
  ACCEPTED: "Accepted",
  REJECTED: "Rejected",
};

export const SHARED_ITEM_KIND_LABELS: Record<string, string> = {
  NOTE: "Note",
  COLLECTION: "Collection",
  SPACE: "Space",
  UNKNOWN: "Unknown",
};
